import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/registro_sanitario/grupo';
import Grupo from './GrupoList';


const ms2p = (state) => {
  return {
    ...state.rs_grupo,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Grupo);